import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/faqs/faqs-bg-header.webp'


const _withScopeId = n => (_pushScopeId("data-v-3f79fa1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "relative"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-screen object-cover",
  style: {"min-height":"200px"}
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 h-full w-full flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold lg:text-7xl md:text-6xl text-4xl text-white text-center font-sarabun" }, " FAQs & Blog ")
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "mt-6 md:mt-20"
}
const _hoisted_6 = { class: "flex flex-col items-center space-y-6 md:mx-0 mx-4" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "toggle" }
const _hoisted_9 = {
  key: 0,
  class: "content md:pr-16"
}
const _hoisted_10 = {
  class: "container mx-auto grid mt-0 md:mt-20 mb-14 px-4",
  style: {"max-width":"1220px"}
}
const _hoisted_11 = { class: "order-2 md:order-1" }
const _hoisted_12 = {
  key: 0,
  class: "text-4xl font-semibold lg:justify-self-start justify-self-center"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Update ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-primary-dark" }, "Blog", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" about the project. ")
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "text-4xl font-semibold"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Results for ")
const _hoisted_19 = { class: "text-primary-dark" }
const _hoisted_20 = { class: "order-1 md:order-2 py-16 md:py-9 block md:hidden" }
const _hoisted_21 = { class: "order-3 grid md:grid-cols-3 grid-cols-1 mt-6 min-h-screen mb-6" }
const _hoisted_22 = {
  key: 0,
  class: "flex flex-wrap -mx-2"
}
const _hoisted_23 = { class: "card-blog mx-auto" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "blog__content" }
const _hoisted_26 = { class: "text-xl" }
const _hoisted_27 = { class: "text-sm text-gray-description flex items-start" }
const _hoisted_28 = { class: "ml-1 font-light" }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "lg:p-9 p-4 md:block hidden" }
const _hoisted_31 = {
  key: 0,
  class: "mt-10"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-2xl font-semibold" }, "Recommended", -1))
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "text-sm ml-4 flex flex-col justify-center" }
const _hoisted_35 = { class: "font-medium" }
const _hoisted_36 = { class: "font-light text-gray-description whitespace-nowrap" }

import { ref, watch, computed, onMounted } from 'vue';
import { Icon } from '@iconify/vue';
import { useRouter, useRoute } from 'vue-router';
import useBlogs from '@/composables/useBlogs';
import { BlogsEntities, Params } from '@/types/Blogs';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();
const faqs = ref([
  {
    title: 'Q : Do NFT and token have any value?',
    content:
      'A : Bring Back The Forest’s NFT and Token function as Information token. Their purpose is to inform the donors regarding the donation and the amount of carbon sequestered, as well as the increased number of forest species that results from the donation. In short, the NFT and Token’s purpose is to inform the donors about the result of their contribution to save our planet, thus they have no value.',
    isOpend: false,
  },
  {
    title:
      'Q : Must I accept the NFT or the Token if I wish to make a donation?',
    content:
      'A : BBTF’s NFT and Token are Information token used to inform the donors regarding the donation, therefore the donors can choose whether to accept them.',
    isOpend: false,
  },
  {
    title: 'Q : Where is the forest’s location?',
    content:
      'A : Our forest is located in parts of Thailand where the hot-humid weather fosters the most suitable condition for our trees to grow and thrive.',
    isOpend: false,
  },
]);
const pageCurrent = ref<number>(1);
const pageSize = ref<number>(10);
const query = ref<string>('');
const { getBlogs, blogs, filterBlogsRecommended, formatDate } = useBlogs();
const blogsRecommended = ref<BlogsEntities[]>();
const payload = ref<Params>({
  page: pageCurrent.value,
  size: pageSize.value,
  query: route.query.q as string,
});
onMounted(async () => {
  await getBlogs(payload.value);
  getRecommended();
});

const getRecommended = async () => {
  const sizeRecommended = 5;
  const recommended = await filterBlogsRecommended(blogs.value.entities);
  const random =
    Math.floor(Math.random() * recommended.length) - sizeRecommended;
  blogsRecommended.value =
    random > 0
      ? recommended.slice(random, random + sizeRecommended)
      : recommended.slice(0, sizeRecommended);
};
const searchBlog = ref();

watch(searchBlog, (val) => {
  if (val != '') {
    router.push({
      query: {
        q: val,
      },
    });
  } else {
    router.push({
      query: {},
    });
  }
});

watch(blogs, () => {
  getRecommended();
});

watch(pageCurrent, async (val: number) => {
  payload.value = { ...payload.value, page: val };

  await getBlogs(payload.value);
  getRecommended();
});

watch(
  () => route,
  async (val) => {
    query.value = val.query.q as string;
    searchBlog.value = query.value;
    payload.value = {
      page: 1,
      query: query.value,
      size: pageSize.value,
    };
    await getBlogs(payload.value);
  },
  { deep: true, immediate: true }
);

const noQuery = computed(() => {
  return route.query.q === '' || route.query.q === undefined;
});

return (_ctx: any,_cache: any) => {
  const _component_BaseInputText = _resolveComponent("BaseInputText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseEmpty = _resolveComponent("BaseEmpty")!
  const _component_BasePagination = _resolveComponent("BasePagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(noQuery))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true),
    (_unref(noQuery))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faqs.value, (f, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "collapsible",
                key: i
              }, [
                _createElementVNode("div", {
                  onClick: ($event: any) => (f.isOpend = !f.isOpend)
                }, [
                  _createElementVNode("div", null, _toDisplayString(f.title), 1),
                  _createElementVNode("div", _hoisted_8, [
                    (!f.isOpend)
                      ? (_openBlock(), _createBlock(_unref(Icon), {
                          key: 0,
                          icon: "akar-icons:plus",
                          class: "plus"
                        }))
                      : (_openBlock(), _createBlock(_unref(Icon), {
                          key: 1,
                          icon: "akar-icons:minus",
                          class: "minus"
                        }))
                  ])
                ], 8, _hoisted_7),
                (f.isOpend)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("p", null, _toDisplayString(f.content), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_unref(noQuery))
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _hoisted_16))
          : (_openBlock(), _createElementBlock("p", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(route).query.q), 1)
            ]))
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_BaseInputText, {
          id: "nft-search",
          placeholder: "Search",
          modelValue: searchBlog.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchBlog).value = $event)),
          "data-testid": "serach-blog-input"
        }, {
          "head-icon": _withCtx(() => [
            _createVNode(_unref(Icon), {
              icon: "bx:bx-search",
              class: "text-2xl"
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", {
          class: _normalizeClass(["col-span-2 justify-self-center", { 'lg:justify-self-start': _unref(blogs).entities.length }])
        }, [
          (_unref(blogs).entities.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(blogs).entities, (b, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "w-full md:w-1/2 lg:w-1/3",
                    key: i
                  }, [
                    _createVNode(_component_router_link, {
                      to: `/landing/faqs/blog/${b.id}`,
                      class: "block m-2"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("img", {
                            src: b.image.original_image_url,
                            alt: "",
                            class: "object-cover mx-auto rounded-md",
                            style: {"height":"224px"}
                          }, null, 8, _hoisted_24),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, _toDisplayString(b.title), 1),
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_unref(Icon), {
                                class: "mt-1",
                                icon: "akar-icons:clock"
                              }),
                              _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(formatDate)(b.updated_at)), 1)
                            ])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createVNode(_component_BaseEmpty, {
                  src: require('@/assets/svg/empty-search.svg'),
                  class: "flex-1",
                  description: "No results found."
                }, null, 8, ["src"])
              ])),
          (
              _unref(blogs).entities.length && (_unref(blogs).page_information.page || 0) > 1
            )
            ? (_openBlock(), _createBlock(_component_BasePagination, {
                key: 2,
                onPageCurrent: _cache[1] || (_cache[1] = ($event: any) => (pageCurrent.value = $event)),
                list: _unref(blogs).page_information.count,
                "data-per-page": _unref(blogs).page_information.size
              }, null, 8, ["list", "data-per-page"]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", null, [
            _createVNode(_component_BaseInputText, {
              id: "nft-search",
              placeholder: "Search",
              modelValue: searchBlog.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchBlog).value = $event)),
              "data-testid": "serach-blog-input"
            }, {
              "head-icon": _withCtx(() => [
                _createVNode(_unref(Icon), {
                  icon: "bx:bx-search",
                  class: "text-2xl"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (blogsRecommended.value?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _hoisted_32,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blogsRecommended.value, (r, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, [
                    _createVNode(_component_router_link, {
                      class: "flex mt-4",
                      to: `/landing/faqs/blog/${r.id}`
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: r.image.original_image_url,
                          alt: "",
                          class: "w-20 h-20 object-cover rounded-lg"
                        }, null, 8, _hoisted_33),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("p", _hoisted_35, _toDisplayString(r.title), 1),
                          _createElementVNode("p", _hoisted_36, _toDisplayString(_unref(formatDate)(r.updated_at)), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})